"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.compileBlockStyleVars = void 0;
var GetBlockStyle_1 = require("@CommonFrontendBackend/StyleServiceV2/GetBlockStyle");
var dynamic_1 = require("@vanilla-extract/dynamic");
var BlockStyles_css_1 = require("Styles/BlockStyles/BlockStyles.css");
var BlockStyleTypes_1 = require("@CommonFrontendBackend/StyleServiceV2/BlockStyleTypes");
var commonTypes_1 = require("@CommonFrontendBackend/StyleServiceV2/Config/BlockConfig/commonTypes");
var lodash_1 = require("lodash");
var defaultStyles_1 = require("./defaultStyles");
var blockWidthMappings_1 = __importDefault(require("@CommonFrontendBackend/StyleServiceV2/Config/BlockConfig/blockWidthMappings"));
var SideBySide_css_1 = require("@CommonFrontend/ContentTokens/SharedWidgetComponents/SideBySide/SideBySide.css");
var blockSpacingMappings_1 = __importDefault(require("@CommonFrontendBackend/StyleServiceV2/Config/BlockConfig/blockSpacingMappings"));
var compileBlockStyleVars = function (block, colors) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    var _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0;
    var styleVars = {};
    var getColorFn = (0, GetBlockStyle_1.GetColor)(colors);
    if (hasStyle(block.style)) {
        if (block.style.background && !hasBackgroundAsset(block.style)) {
            var backgroundColor = getColorFn(block.style.background);
            Object.assign(styleVars, (_a = {},
                _a[BlockStyles_css_1.blockStyleVars.backgroundColor] = backgroundColor,
                _a));
        }
        if ((0, BlockStyleTypes_1.isTextStyle)(block.style)) {
            if (block.style.background.url && block.style.background.type === "image") {
                Object.assign(styleVars, (_b = {},
                    _b[BlockStyles_css_1.blockStyleVars.backgroundImage] = "url(".concat(block.style.background.url, ")"),
                    _b));
            }
            if (block.style.background.videoThumbnail && block.style.background.type === "video") {
                Object.assign(styleVars, (_c = {},
                    _c[BlockStyles_css_1.blockStyleVars.backgroundVideoThumbnail] = "url(".concat(block.style.background.videoThumbnail, ")"),
                    _c));
            }
            if (hasBackgroundAsset(block.style)) {
                var tintColor = defaultStyles_1.defaultRgbaColor;
                var backgroundBlur = (_m = (_l = (_k = block.style) === null || _k === void 0 ? void 0 : _k.background) === null || _l === void 0 ? void 0 : _l.blur) !== null && _m !== void 0 ? _m : 0;
                if (((_p = (_o = block.style) === null || _o === void 0 ? void 0 : _o.background) === null || _p === void 0 ? void 0 : _p.tintColor) && "abs" in ((_r = (_q = block.style) === null || _q === void 0 ? void 0 : _q.background) === null || _r === void 0 ? void 0 : _r.tintColor)) {
                    tintColor = {
                        abs: block.style.background.tintColor.abs,
                        themeIndex: block.style.background.tintColor.themeIndex,
                        opacity: (_s = block.style.background.tintColor.opacity) !== null && _s !== void 0 ? _s : 0.25,
                    };
                }
                Object.assign(styleVars, (_d = {},
                    _d[BlockStyles_css_1.blockStyleVars.backgroundTintColor] = getColorFn(tintColor),
                    _d[BlockStyles_css_1.blockStyleVars.backgroundTintBlendMode] = ((_t = block.style) === null || _t === void 0 ? void 0 : _t.background.tintBlendMode) === commonTypes_1.TintBlendModeTypes.Blend ? "multiply" : "normal",
                    _d[BlockStyles_css_1.blockStyleVars.backgroundCardColor] = ((_u = block.style.background.card) === null || _u === void 0 ? void 0 : _u.enabled)
                        ? getColorFn((_w = (_v = block.style.background.card) === null || _v === void 0 ? void 0 : _v.color) !== null && _w !== void 0 ? _w : defaultStyles_1.defaultRgbaColor)
                        : "transparent",
                    _d[BlockStyles_css_1.blockStyleVars.backgroundBlur] = "".concat(backgroundBlur, "px"),
                    _d));
            }
            Object.assign(styleVars, (_e = {},
                _e[BlockStyles_css_1.blockStyleVars.minBlockHeight] = blockHeight((_y = (_x = block.style) === null || _x === void 0 ? void 0 : _x.blockHeight) !== null && _y !== void 0 ? _y : "none"),
                _e));
        }
        if ((_z = block.style) === null || _z === void 0 ? void 0 : _z.blockWidth) {
            var rawBlockWidth = block.style.blockWidth;
            if (typeof rawBlockWidth === "object") {
                var width = rawBlockWidth.width, unit = rawBlockWidth.unit;
                Object.assign(styleVars, (_f = {},
                    _f[BlockStyles_css_1.blockStyleVars.blockWidth] = "".concat(width).concat(unit),
                    _f));
            }
            else {
                var percentageBlockWidth = blockWidthMappings_1.default[rawBlockWidth];
                Object.assign(styleVars, (_g = {},
                    _g[BlockStyles_css_1.blockStyleVars.blockWidth] = percentageBlockWidth,
                    _g[BlockStyles_css_1.blockStyleVars.blockWidthForSBS] = percentageBlockWidth.replace("%", ""),
                    _g[BlockStyles_css_1.blockStyleVars.sideBySideMediumRatio] = percentageBlockWidth === "90%" ? SideBySide_css_1.SBS_CONTENT_WIDTH_RATIOS.MEDIUM : SideBySide_css_1.SBS_CONTENT_WIDTH_RATIOS.LARGE,
                    _g));
            }
        }
        if ((_0 = block.style) === null || _0 === void 0 ? void 0 : _0.blockSpacing) {
            if (typeof block.style.blockSpacing === "object") {
                var blockSpacing = block.style.blockSpacing;
                Object.assign(styleVars, (_h = {},
                    _h[BlockStyles_css_1.blockStyleVars.blockSpacing.before] = "".concat(blockSpacing.before, "%"),
                    _h[BlockStyles_css_1.blockStyleVars.blockSpacing.after] = "".concat(blockSpacing.after, "%"),
                    _h));
            }
            else {
                var blockSpacing = blockSpacingMappings_1.default[block.style.blockSpacing];
                Object.assign(styleVars, (_j = {},
                    _j[BlockStyles_css_1.blockStyleVars.blockSpacing.before] = blockSpacing,
                    _j[BlockStyles_css_1.blockStyleVars.blockSpacing.after] = blockSpacing,
                    _j));
            }
        }
    }
    return (0, dynamic_1.assignInlineVars)(styleVars);
};
exports.compileBlockStyleVars = compileBlockStyleVars;
var blockHeight = function (setting) {
    switch (setting) {
        case "small": {
            return "33vh";
        }
        case "medium": {
            return "65vh";
        }
        case "large": {
            return "100vh";
        }
        default: {
            return "auto";
        }
    }
};
var hasStyle = function (style) {
    return !!style && !(0, lodash_1.isEmpty)(style);
};
var hasBackgroundAsset = function (style) {
    return (0, BlockStyleTypes_1.isTextStyle)(style) && (style.background.type === "image" || style.background.type === "video");
};
